import { Typography,Grid2 } from "@mui/material"
import Styles from "./Web.module.css"

export default function Web() {
    return (
        <>
            <Grid2 className={Styles.maincard}>
                 <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <Typography className={Styles.headingText}>
                        Research for Investors
                    </Typography>
                </div>
                <Typography className={Styles.text}>
                    The strength of the fundamentals determines the success of long-term performance in the market.
                    At Tradeboss, research for investors begins and ends with the 3R Research Philosophy. The combined 25+ years of experience of our Research Desk and the systematic processes we use for our Research recommendations have stood the test of time. Research for investors at Tradeboss has a strong foundation in Fundamental Research.
                </Typography>
            </Grid2>

        </>
    )
}